export default function RegisteredGamesTab() {
    return (
        <h2>Registered Games</h2>
    );
}